/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Buffer } from 'buffer';

import { Component } from 'react';
import { Form, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { Validators } from "../../../shared/utils/Validators";
import { login, setUser } from '../../../shared/settings/auth';
import { SignInTextInput } from '../../../shared/form/FormInput';
import { RenderAppLogo, RenderNoAuthHeaderText } from '../../../shared/components/ConditonalComponent';

import { postApi } from '../../../shared/services/apiHelper';
import { loginApi } from '../../../shared/settings/apiConfig';

import 'bootstrap/dist/css/bootstrap.min.css';
import './SignIn.scss';
import '../NoAuth.scss';

class Signin extends Component {

    constructor(props) {
        super(props);

        this.state = {
            formValid: false,
            formControls: {
                email: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.email()] },
                password: { value: '', valid: false, error: '', validators: [Validators.required()] }
            },
            formLoading: false,
            pwdtype: "password"
        }
    }

    saveValue = (type, event) => {
        this.setState({
            formControls: {
                ...this.state.formControls,
                [type]: {
                    ...this.state.formControls[type],
                    value: event.target.value
                },
            }
        })
    }

    onSignin = () => {
        this.setState({
            formLoading: true
        })
        const payload = {
            data: {
                "username": this.state.formControls.email.value,
                "password": Buffer.from(this.state.formControls.password.value, 'utf-8').toString('base64'),
                "keep-user-logged-in": false
            }
        };
        postApi(loginApi, payload, false).then(response => {
            this.setState({
                formLoading: false
            })
            login(response.data);
            setUser().then((res) => {
                this.props.history.push('/home');
            })
        }).catch(error => {
            this.setState({
                formLoading: false,
                error:   `Sorry, we couldn't find an account with that email and password combination. Please try again or select the Forgot Password link.`
            })
        });
    }

    onInputChange = (controlName, event) => {
        this.setState({
            formControls: {
                ...this.state.formControls,
                [controlName]: Validators.validateFormControl(this.state.formControls[controlName], event.target.value)
            }
        }, () => {
            this.setState({
                formValid: Validators.validateForm(this.state.formControls)
            });
        })
    }

    render() {
        return (
            <div className="signin w-100" >
                <img class="noauth-bg-img" src={`${process.env.PUBLIC_URL}/static/images/signinbg.png`} alt="bg" />
                <div className='scontainer'>
                    
                    <RenderAppLogo />

                    <div className='sigincontent'>
                            <div class="shadow-lg pd-x-5 pb-5 rounded">
                                <RenderNoAuthHeaderText />
                                <Form className="w-100 d-flex flex-column justify-content-center my-1">
                                    <SignInTextInput type={'text'} name={'email'} label={'Email'} placeholder={'Email'}
                                        value={this.state.formControls.email.value} error={this.state.formControls.email.error} onChange={(event) => { this.onInputChange('email', event); }} />
                                    <SignInTextInput type={this.state.pwdtype} name={'password'} label={'Password'} placeholder={'Password'}
                                        value={this.state.formControls.password.value} error={this.state.formControls.password.error} onChange={(event) => { this.onInputChange('password', event); }}
                                        setType={(d) => {
                                            this.setState({
                                                pwdtype: d
                                            })
                                        }} />
                                    <div className="rowcont  justify-content-between my-1">
                                        <Form.Check type="checkbox" id="signin-checkbox" label="Keep me signed in" />
                                        <div className="d-flex align-items-center">
                                            <Link className='d-flex' to="/forgot-password" >
                                                <small className=' text-n' >Forgot Password?</small>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className='mt-3 text-center  text-m' >
                                        {this.state.error ? <span className='text-danger '>{this.state.error}</span> : ''}
                                    </div>
                                    <button type="button" className="d-flex my-2 align-items-center justify-content-center btn btn-secondary sign-btn" onClick={this.onSignin} disabled={!this.state.formValid}>Sign In {this.state.formLoading ? <Spinner className='ms-2' as="span" animation="border" role="status" aria-hidden="true" /> : ''}</button>
                                    {/* <div className='or-cont'>
                                            <text className='or-text'>OR</text>
                                        </div>
                                        <div className='d-flex  justify-content-center align-items-center'>
                                            <img role={"button"} class="align-self-center" src={`${process.env.PUBLIC_URL}/static/images/googleb.png`} alt="logo" height="50px" width="50px" />
                                            <img role={"button"} class="align-self-center" style={{margin :10}} src={`${process.env.PUBLIC_URL}/static/images/fbb.png`} alt="logo" height="50px" width="50px" />
                                            <img role={"button"} class="align-self-center" src={`${process.env.PUBLIC_URL}/static/images/appleb.png`} alt="logo" height="50px" width="50px" />
                                        </div>
                                        <p style={{ textAlign: "center" }}>Not a member yet?   <Link  to="/sign-up" ><span className='text-primary' style={{fontWeight:"bolder"}}>Register now</span></Link></p> */}
                                </Form>
                            </div>
                        </div>
                        <footer className='footer-section'>
                        <a href="https://image.assessmax.com/assessmax/PrivacyPolicy.pdf" target="_blank" rel="noopener noreferrer">Privacy Policy</a> <span style={{fontWeight: 'bold'}}>|</span>
                        <a href="https://image.assessmax.com/assessmax/TermsandConditionsAcceptableandfairUsage.pdf" target="_blank" rel="noopener noreferrer"> Terms and Conditions</a>

                        <div className='footer-txt '>Copyright © 2025 AssessMax. All rights reserved.</div>
                    </footer>
                    </div>           

            </div>
        )
    }
}

export default Signin;